export default __webpack_public_path__ + "static/media/D_Dedo.425e3db6.svg";